import { useState, useEffect } from "react";

// Punto de corte único para toda la app. 768px es donde el nav completo
// (logo + secciones + iconos de sesión) deja de caber en una línea.
export const MOBILE_BREAKPOINT = 768;

export function useIsMobile(breakpoint = MOBILE_BREAKPOINT) {
  // Se inicializa ya con el valor real para no renderizar primero la versión
  // de escritorio y hacer un salto visible al montar.
  const [isMobile, setIsMobile] = useState(
    () => typeof window !== "undefined" && window.innerWidth < breakpoint
  );

  useEffect(() => {
    const mq = window.matchMedia(`(max-width: ${breakpoint - 1}px)`);
    const onChange = e => setIsMobile(e.matches);
    setIsMobile(mq.matches);
    mq.addEventListener("change", onChange);
    return () => mq.removeEventListener("change", onChange);
  }, [breakpoint]);

  return isMobile;
}
